// import request from '@/utils/request'
import { get, post,put,remove } from '@/utils/http.js'
export const roleMenuTreeselect = (roleId) => get('/system/menu/roleMenuTreeselect?roleId=' + roleId+'&platformNum=2');
export const addMenu = (data) => post('/system/menu',{...data,platformNum:2});
export const updateMenu = (data) => put('/system/menu',{...data,platformNum:2});
export const delMenu = (menuId) => remove( '/system/menu/' + menuId);

// 查询定时任务调度列表
// export function listJob(query) {
//   return request({
//     url: '/monitor/job/list',
//     method: 'get',
//     params: query
//   })
// }
export const listJob = (query) => get('/monitor/job/list',query);

// 查询定时任务调度详细
// export function getJob(jobId) {
//   return request({
//     url: '/monitor/job/' + jobId,
//     method: 'get'
//   })
// }
export const getJob = (jobId) => get('/monitor/job/' + jobId);

// 新增定时任务调度
// export function addJob(data) {
//   return request({
//     url: '/monitor/job',
//     method: 'post',
//     data: data
//   })
// }
export const addJob = (data) => post('/monitor/job',data);

// 修改定时任务调度
// export function updateJob(data) {
//   return request({
//     url: '/monitor/job',
//     method: 'put',
//     data: data
//   })
// }
export const updateJob = (data) => put('/monitor/job',data);

// 删除定时任务调度
// export function delJob(jobId) {
//   return request({
//     url: '/monitor/job/' + jobId,
//     method: 'delete'
//   })
// }
export const delJob = (jobId) => remove( '/monitor/job/' + jobId);

// 导出定时任务调度
// export function exportJob(query) {
//   return request({
//     url: '/monitor/job/export',
//     method: 'get',
//     params: query
//   })
// }
export const exportJob = (query) => get('/monitor/job/export',query);

// 任务状态修改
export function changeJobStatus(jobId, status) {
  const data = {
    jobId,
    status
  }

  return put('/monitor/job/changeStatus',data);
}


// 定时任务立即执行一次
export function runJob(jobId, jobGroup) {
  const data = {
    jobId,
    jobGroup
  }
  // return request({
  //   url: '/monitor/job/run',
  //   method: 'put',
  //   data: data
  // })
  return put('/monitor/job/run',data);

}